import { UnitsEnum } from '../../impl/blfApi/apiConstants';
import { useGetUserMeQuery } from '../../impl/blfApi/endpoints/users';
import { UserSettings } from '../../impl/blfApi/schemas/user';

export const defaultUserSettings: UserSettings = {
  language: 'en',
  units: UnitsEnum.imperial,
  onboardingComplete: false,
  cropTypes: [],
};

export const useSettings = (): {
  settings: UserSettings | undefined;
  isSettingsLoading: boolean;
} => {
  const { data: user, isLoading, isUninitialized } = useGetUserMeQuery();

  return {
    settings: user?.settings || undefined,
    isSettingsLoading: isLoading || isUninitialized,
  };
};
